import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import '../Styles/Carousel.css';
import { getMediaProvider, isGoogleDriveThumbnailUrl, normalizeMediaUrl } from '../Utils/mediaUrls';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];
const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.webm', '.m4v'];

const getPathname = (url) => {
  try {
    return new URL(url).pathname.toLowerCase();
  } catch (error) {
    return String(url || '').toLowerCase();
  }
};

const hasExtension = (url, extensions) => {
  const pathname = getPathname(url);

  return extensions.some((extension) => pathname.endsWith(extension));
};

const getMediaUrl = (item) => (typeof item === 'string' ? item : item?.url || item?.src || item?.viewUrl);

const getMediaType = (item) => {
  if (!item || typeof item === 'string') {
    return '';
  }

  return String(item.mediaType || item.type || item.contentType || item.mimeType || '').toLowerCase();
};

const isImageMedia = (item) => {
  const url = getMediaUrl(item);
  const mediaType = getMediaType(item);

  return mediaType.includes('image') || isGoogleDriveThumbnailUrl(url) || hasExtension(url, IMAGE_EXTENSIONS);
};

const isVideoMedia = (item) => {
  const mediaType = getMediaType(item);

  return mediaType.includes('video') || hasExtension(getMediaUrl(item), VIDEO_EXTENSIONS);
};

const Carousel = ({ media, onMediaClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 3;

  const handleClickLeft = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex - itemsPerPage;
      return newIndex < 0 ? media.length - (Math.abs(newIndex) % media.length) : newIndex;
    });
  };

  const handleClickRight = () => {
    setCurrentIndex((prevIndex) => (prevIndex + itemsPerPage) % media.length);
  };

  const handleItemClick = (index) => {
    const clickedMedia = media[currentIndex + index];
    onMediaClick(clickedMedia);
  };

  return (
    <div className="carousel-container">
      <button className='button-cars' onClick={handleClickLeft}>{'<'}</button>
      <div className="carousel-items-container">
        <div
          className="carousel-items"
          style={{
            transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)`,
          }}
        >
          {media.map((item, index) => {
            const mediaUrl = getMediaUrl(item);
            const isDriveMedia = getMediaProvider(mediaUrl) === 'google-drive';
            const shouldRenderImage = isImageMedia(item) || (isDriveMedia && !isVideoMedia(item));
            const shouldRenderVideo = isVideoMedia(item);

            return (
            <div
              key={index}
              className="carousel-item"
              onClick={() => handleItemClick(index)}
            >
              {shouldRenderImage ? (
                <img
                  src={normalizeMediaUrl(mediaUrl, 'image')}
                  alt=""
                  className="carousel-image"
                />
              ) : isDriveMedia && shouldRenderVideo ? (
                <iframe
                  src={normalizeMediaUrl(mediaUrl, 'preview')}
                  title={`carousel-media-${index}`}
                  className="carousel-video"
                  allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                  allowFullScreen
                />
              ) : shouldRenderVideo ? (
                <ReactPlayer
                  url={mediaUrl}
                  controls
                  className="carousel-video"
                />
              ) : (
                <ReactPlayer
                  url={mediaUrl}
                  controls
                  className="carousel-video"
                />
              )}
            </div>
            );
          })}
        </div>
      </div>
      <button className='button-cars' onClick={handleClickRight}>{'>'}</button>
    </div>
  );
};

export default Carousel;
